import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
/* babel-plugin-inline-import '../../assets/images/logo-small.svg' */
const LogoSVG = "data:image/svg+xml;base64,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";
import { SideBar } from "./sidebar";
import { TopMenu } from "./topmenu";

/**
 *
 * @param {object} props
 * @param {string} props.pageTitle
 * @param {import("./sidebar").SideBar | JSX.Element} [props.SideBar]
 * @param {() => any} props.logout
 * @param {(props: { children: any, to: string }) => JSX.Element} [props.Link]
 * @param {(url: string) => boolean} [props.isUrlActive]
 * @param {string} props.userName
 * @param {{ name: string, Icon: JSX.Element | (() => JSX.Element), url: string, disabled?: boolean }[]} [props.items]
 * @param {any} props.children
 * @returns {JSX.Element}
 */
export const AltLayout = ({
  pageTitle,
  SideBar,
  userName,
  items,
  logout,
  Link,
  isUrlActive,
  children
}) => {
  const pageBodyClass = classNames("flex-grow min-h-0 max-h-full overflow-hidden bg-en-yellow-100", "border-gray-400 border-l-2 border-solid");
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-screen w-screen overflow-y-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-16 bg-en-gray-800 flex flex-row justify-start items-center"
  }, /*#__PURE__*/React.createElement("a", {
    className: "flex-grow p-2 h-16",
    href: "/"
  }, /*#__PURE__*/React.createElement("img", {
    className: "h-full inline-block",
    src: LogoSVG,
    alt: "logo"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-white ml-4 text-2xl font-bold"
  }, pageTitle)), /*#__PURE__*/React.createElement(TopMenu, {
    userName: userName,
    logout: logout
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex h-screen w-screen overflow-y-hidden"
  }, typeof SideBar === "function" ? /*#__PURE__*/React.createElement(SideBar, {
    items: items,
    Link: Link,
    isUrlActive: isUrlActive
  }) : SideBar, /*#__PURE__*/React.createElement("div", {
    className: pageBodyClass
  }, children)));
};
AltLayout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  SideBar: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  children: PropTypes.any.isRequired,
  isUrlActive: PropTypes.func,
  Link: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  logout: PropTypes.func.isRequired,
  items: PropTypes.array,
  userName: PropTypes.string.isRequired
};
AltLayout.defaultProps = {
  SideBar
};